export function SecurityDisclosure() {
  return (
    <main className="login-shell">
      <section className="login-card">
        <p className="eyebrow">FrancaCyan Security</p>
        <h1>Report a security concern</h1>
        <p className="login-copy">
          Send security reports for FrancaCyan SS Core to{" "}
          <a href="mailto:security@solutulos.com">security@solutulos.com</a>.
        </p>
        <p className="login-copy">
          Include enough detail to reproduce and triage the concern. Do not send
          production secrets, destructive proof of exploitation, or unnecessary
          personal data.
        </p>
      </section>
    </main>
  );
}
